import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./VideoSection.css"; // Your CSS file
import video1 from '../Components/Images/video3.mp4'
import video2 from '../Components/videos/zartijvideo1.mp4'

const VideoSection = () => {
  return (
    <section className="w3l-video" id="video">
      <div className="video-overlay"></div>
      <div className="video-mid-w3 py-5">
        <Container>
          <Row className="align-items-center">
            {/* Left Column - Text Content */}
            <Col lg={6} className="mb-5 mb-lg-0 pe-lg-3 text-white">
              <div className="title-content text-left">
                <h6 className="title-subhny mb-2">Time to grow</h6>
                <h3 className="title-w3l two">Make better ideas happen fast</h3>
              </div>
              <p className="mt-md-4 mt-3">
              From retail security to industrial printing and POS systems — Zartec Solutions delivers cutting-edge technology for every business need. Reliable support, fast delivery, and trusted service across Bahrain.
              </p>
              <div className="w3l-two-buttons mt-4">
                <Button  className="me-2 btn-primary" style={{fontFamily:"Poppins"}}>Explore Products</Button>
                <Button variant="outline-light">Get a Free Quote</Button>
              </div>
            </Col>

            {/* Right Column - Video */}
            <Col lg={6} className="ps-lg-5">
              <div className="video-container position-relative">
                <div className="play-button-wrapper">
                  <a href={video2} className="popup-with-zoom-anim play-view">
                    <span className="video-play-icon">
                      <span className="fa fa-play"></span>
                    </span>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default VideoSection;